export default "__VITE_ASSET__DzvQXXOC__"